import { OnboardingProjects } from "../features/OnboardingGuide/ProjectGuide/ProjectGuide";
import { useRouteHistory } from "../hooks/useRouteHistory";

export function DefaultRenders() {
    
    useRouteHistory();

    
    return (
        <>
        </>
    )
}